<template>
  <v-row no-gutters>
    <v-col cols="12">
      <div class="exact-copy-wrapper">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-switch
                :input-value="isExactCopy"
                :label="$t('workPackages.exactCopy')"
                :disabled="disabled"
                primary
                hide-details
                class="font-weight-regular"
                @change="$emit('change', $event)"
              />
            </div>
          </template>
          <span>{{ $t('workPackages.exactCopyTooltip') }}</span>
        </v-tooltip>
        <div v-if="isExactCopy" class="text-body-2 grey--text mt-1">
          {{ $t('workPackages.exactCopyHelpText') }}
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    isExactCopy: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.exact-copy-wrapper {
  height: 45px;
  padding-top: 4px;
}
</style>
